<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        Amortization/Recouring - Form
        <div class="card-header-actions">
          <button
            v-if="saveEnabled"
            class="btn btn-primary mr-1"
            @click="save()"
          >
            <i class="fa fa-save"></i> Save
          </button>
          <b-button class="btn btn-danger mr-1" @click="close()">
            <i class="fa fa-close"></i> Close</b-button
          >
        </div>
      </div>
      <b-row>
        <b-col cols="7" class="pr-5">
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend
                  ><label>Amortization Code</label></b-input-group-prepend
                >
                <b-form-input v-model="model.kodeamor" readonly></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-input-group v-if="model.useAPUnbill == 1">
            <b-input-group-prepend
              ><label>Reference to</label></b-input-group-prepend
            >
            <b-form-radio-group v-model="model.useAPUnbill" class="ml-1 pt-1">
              <b-form-radio value="1">AP Contract/Un Bill</b-form-radio>
              <b-form-radio value="0">AP Trade</b-form-radio>
            </b-form-radio-group>
            <b-form-input
              readonly
              v-model="model.nomorap"
            ></b-form-input>
            <b-input-group-append v-if="saveEnabled">
              <b-btn text="Button" @click="lkuApunbillShow = true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
          </b-input-group>
          <b-input-group v-else>
            <b-input-group-prepend
              ><label>Reference to</label></b-input-group-prepend
            >
            <b-form-radio-group v-model="model.useAPUnbill" class="ml-1 pt-1">
              <b-form-radio value="1">AP Contract/Un Bill</b-form-radio>
              <b-form-radio value="0">AP Trade</b-form-radio>
            </b-form-radio-group>
            <b-form-input
              v-model="model.nomorap"
              @keyup.13.native="lkuApShow = true"
            ></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" @click="lkuApShow = true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
          </b-input-group>

          <b-input-group>
            <b-input-group-prepend
              ><label>Description</label></b-input-group-prepend
            >
            <b-form-input
              v-model="model.keterangan"
              :state="!$v.model.keterangan.$error"
            ></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend
              ><label>Debit Account</label></b-input-group-prepend
            >
            <b-form-input
              v-model="model.db_kodeacc"
              :state="!$v.model.db_kodeacc.$error"
            ></b-form-input>
            <b-form-input
              readonly
              v-model="model.db_namaacc"
              :state="!$v.model.db_kodeacc.$error"
              style="width: 50% !important"
            ></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" @click="showLkuCoa('debit')">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend
              ><label>Credit Account</label></b-input-group-prepend
            >
            <b-form-input
              v-model="model.kr_kodeacc"
              :state="!$v.model.kr_kodeacc.$error"
            ></b-form-input>
            <b-form-input
              readonly
              v-model="model.kr_namaacc"
              :state="!$v.model.kr_kodeacc.$error"
              style="width: 50% !important"
            ></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" @click="showLkuCoa('credit')">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
          </b-input-group>
          <b-row>
            <b-col cols="7">
              <b-input-group>
                <b-input-group-prepend
                  ><label style="width: 165px !important"
                    >Amortized Amt.(original)</label
                  ></b-input-group-prepend
                >
                <b-input-group-prepend>
                  <b-form-select
                    class="input-group-text"
                    v-model="model.matauang"
                    :plain="true"
                    :options="currency"
                    :state="!$v.model.matauang.$error"
                  ></b-form-select>
                </b-input-group-prepend>
                <my-number
                  class="form-control text-right"
                  separator=","
                  v-model="model.origincost"
                  :precision="2"
                  :state="!$v.model.origincost.$error"
                ></my-number>
              </b-input-group>
            </b-col>
            <b-col cols="5">
              <b-input-group>
                <b-input-group-prepend
                  ><label>{{ lblExchRate }}</label></b-input-group-prepend
                >
                <my-number
                  :disabled="model.matauang === uanguser"
                  class="form-control text-right"
                  separator=","
                  v-model="model.kurstrx"
                ></my-number>
              </b-input-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col class="pr-4" cols="5">
          <!-- <b-input-group >
                      <b-input-group-prepend><span class="pt-2">Ref. PKS/SKA</span></b-input-group-prepend>
                        <b-form-input v-model="model.agreement_no" @keyup.13.native="lkuSkaShow=true" ></b-form-input>
                        <b-input-group-append>
                        <b-btn text="Button" @click="lkuSkaShow=true" >
                            <i class="fa fa-search"></i>
                        </b-btn>
                        </b-input-group-append>
                    </b-input-group> -->
          <v-dim :model="model"></v-dim>
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col cols="7" class="pr-5">
          <b-row>
            <b-col lg="7">
              <b-input-group>
                <b-input-group-prepend
                  ><label style="width: 165px !important"
                    >Amortized Amount (LCY)</label
                  ></b-input-group-prepend
                >
                <b-input-group-prepend
                  ><span class="input-group-text pl-4 pr-4">{{
                    uanguser
                  }}</span></b-input-group-prepend
                >
                <my-number
                  class="form-control text-right"
                  separator=","
                  v-model="model.totalakan"
                  :precision="2"
                  :state="!$v.model.totalakan.$error"
                  disabled
                ></my-number>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="7">
              <b-input-group>
                <b-input-group-prepend
                  ><label style="width: 165px !important"
                    >Telah di-Amortisasi</label
                  ></b-input-group-prepend
                >
                <b-input-group-prepend
                  ><span class="input-group-text pl-4 pr-4">{{
                    uanguser
                  }}</span></b-input-group-prepend
                >
                <my-number
                  class="form-control text-right"
                  separator=","
                  v-model="model.realisasi"
                  :precision="2"
                  disabled
                ></my-number>
              </b-input-group>
            </b-col>
            <b-col lg="5">
              <b-input-group>
                <b-input-group-prepend
                  ><label style="width: 90px !important"
                    >Balance</label
                  ></b-input-group-prepend
                >
                <b-input-group-prepend
                  ><span class="input-group-text pl-4 pr-4">{{
                    uanguser
                  }}</span></b-input-group-prepend
                >
                <my-number
                  class="form-control text-right"
                  separator=","
                  v-model="model.outstand"
                  :precision="2"
                  disabled
                ></my-number>
              </b-input-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="7">
              <b-input-group>
                <b-input-group-prepend
                  ><label style="width: 165px !important"
                    >Amortization Period</label
                  ></b-input-group-prepend
                >
                <b-form-input
                  v-model="model.lamathn"
                  type="number"
                  @change="update_monthly_amortisasi"
                ></b-form-input>
                <b-input-group-append>
                  <span class="input-group-text mr-2">Year</span>
                </b-input-group-append>
                <b-form-input
                  v-model="model.lamabln"
                  type="number"
                  @change="update_monthly_amortisasi"
                ></b-form-input>
                <b-input-group-append>
                  <span class="input-group-text">Month</span>
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col cols="5">
              <b-input-group>
                <b-input-group-prepend
                  ><label style="width: 90px !important"
                    >Starting</label
                  ></b-input-group-prepend
                >
                <b-form-input
                  v-model="model.tglawal"
                  type="date"
                  @change="update_monthly_amortisasi"
                ></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="7">
              <b-input-group>
                <b-input-group-prepend
                  ><label style="width: 165px !important"
                    >Amortized Amt. / Month</label
                  ></b-input-group-prepend
                >
                <b-input-group-prepend
                  ><span class="input-group-text pl-4 pr-4">{{
                    uanguser
                  }}</span></b-input-group-prepend
                >
                <my-number
                  class="form-control text-right"
                  separator=","
                  v-model="model.Nilaisusut"
                  :precision="2"
                  :state="!$v.model.Nilaisusut.$error"
                ></my-number>
              </b-input-group>
            </b-col>
            <b-col cols="5">
              <b-input-group>
                <b-input-group-prepend
                  ><label style="width: 90px !important"
                    >Ending</label
                  ></b-input-group-prepend
                >
                <b-form-input
                  v-model="model.tglAkhirAmor"
                  type="date"
                ></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="7">
              <b-input-group>
                <b-input-group-prepend
                  ><label style="width: 165px !important"
                    >Realization Amount</label
                  ></b-input-group-prepend
                >
                <b-input-group-prepend
                  ><span class="input-group-text pl-4 pr-4">{{
                    uanguser
                  }}</span></b-input-group-prepend
                >
                <my-number
                  class="form-control text-right"
                  separator=","
                  v-model="model.realisasi"
                  :precision="2"
                  disabled
                ></my-number>
              </b-input-group>
            </b-col>
            <b-col lg="5">
              <b-input-group>
                <b-input-group-prepend
                  ><label style="width: 90px !important"
                    >Balance</label
                  ></b-input-group-prepend
                >
                <b-input-group-prepend
                  ><span class="input-group-text pl-4 pr-4">{{
                    uanguser
                  }}</span></b-input-group-prepend
                >
                <my-number
                  class="form-control text-right"
                  separator=","
                  v-model="model.outstand"
                  :precision="2"
                  disabled
                ></my-number>
              </b-input-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col class="pr-4" cols="5">
          <div class="table-wraper">
            <b-table
              class="mb-0"
              ref="table"
              outlined
              responsive
              hover
              small
              style="font-size: smaller"
              :items="amortzHist.items"
              :fields="amortzHist.fields"
            >
              <template v-slot:cell(index)="data">
                {{ data.index + 1 }}
              </template>
              <template v-slot:cell(tgljadwal)="data">
                <span v-if="data.item.tgljadwal"
                  >{{ data.item.tgljadwal | moment("DDMMMYYYY") }}
                </span>
              </template>
              <template v-slot:cell(tgl_gl)="data">
                <span v-if="data.item.tgl_gl"
                  >{{ data.item.tgl_gl | moment("DDMMMYYYY") }}
                </span>
              </template>
              <template v-slot:cell(jmlamor)="data">
                {{ data.item.jmlamor | numFormat("0,0.00") }}
              </template>
              <template v-slot:cell(akumulasi)="data">
                {{ data.item.akumulasi | numFormat("0,0.00") }}
              </template>
            </b-table>
          </div>
        </b-col>
      </b-row>
      <b-row class="justify-content-center mt-2">
        <button v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()">
          <i class="fa fa-save"></i> Save
        </button>
        <b-button class="btn btn-danger mr-1" @click="close()">
          <i class="fa fa-close"></i> Close</b-button
        >
      </b-row>
    </b-card>
    <b-modal
      v-model="lkuCoaShow"
      size="lg"
      :hide-footer="true"
      title="List of GL Account"
      :centered="true"
      :lazy="true"
    >
      <lku-coa @click="onSelectLkuCoa" :tahun="tahun" :key="tahun"></lku-coa>
    </b-modal>
    <b-modal
      v-model="lkuApShow"
      size="lg"
      :hide-footer="true"
      title="List of AP Prepaid"
      :centered="true"
      :lazy="true"
    >
      <lku-ap @click="onSelectLkuAp"></lku-ap>
    </b-modal>
    <!-- <b-modal v-model="lkuSkaShow" size="lg" :hide-footer="true" title="List PKS/Agreement " :centered="true" :lazy="true">
            <lku-ska @click="onSelectLkuSka" ></lku-ska>
        </b-modal>         -->
    <b-modal
      v-model="lkuApunbillShow"
      size="lg"
      :hide-footer="true"
      title="List of AP Contract"
      :centered="true"
    >
      <lku-apunbill
        @click="onSelectLkuApUnbill"
        :vendor_id="model.vendor_id"
        :vendor="model.vendorinfo"
        :key="model.vendor_id"
      ></lku-apunbill>
    </b-modal>
  </div>
</template>

<style lang="scss">
.table-wraper {
  width: 100%;
  height: 180px;
  overflow-x: auto;
  overflow-y: auto;
  border: 1px solid silver;
}
</style>

<script>
import toastr from "mini-toastr";
import moment from "moment";
import myNumber from "../../components/my-number";
import vDim from "../lookup/dim";
import lkuCoa from "../lookup/lkuCoa";
import lkuAp from "../lookup/lkuApprepaid";
// import lkuSka from "../lookup/lkuCpAgreementPrice";
import lkuApunbill from "../lookup/lkuApkontrak";
// import jurnal from "../../apis/jurnal";
// import dimension from "../../apis/dimension";
import { validationMixin } from "vuelidate";
import {
  required,
  minValue,
  maxLength,
  numeric,
} from "vuelidate/lib/validators";
import amortization from "../../apis/amortization";
toastr.init();

export default {
  components: { myNumber, vDim, lkuAp, lkuCoa, lkuApunbill },
  mixins: [validationMixin],
  validations: {
    model: {
      tglawal: { required },
      keterangan: { required },
      matauang: { required },
      db_kodeacc: { required },
      kr_kodeacc: { required },
      origincost: { required },
      totalakan: { required, minValue: minValue(1) },
      Nilaisusut: { required, minValue: minValue(1) },
      kurstrx: { required, minValue: minValue(0.0001) },
      // apdtlkey: {required : (function() {
      //     if ((this.model.useAPUnbill || 0) == 1) {
      //         return true;
      //     } else if (!(this.model.apdtlkey)){
      //         return false;
      //     } else return true;
      // })},
      // kontrakkey: {required : (function() {
      //     if ((this.model.useAPUnbill || 0) == 0) {
      //         return true;
      //     } else if (!(this.model.kontrakkey)){
      //         return false;
      //     } else return true;
      // })},
    },
  },
  data() {
    return {
      saveEnabled: true,
      lkuApunbillShow: false,
      lkuApShow: false,
      lkuSkaShow: false,
      lkuCoaShow: false,
      lkuCoaCaller: "debit",

      tahun: (this.$store.state.user.tglaktif || "").substring(0, 4),
      coa: [],
      model: {
        Dim1Info: "",
        Dim2Info: "",
        Dim3Info: "",
        Dim4Info: "",
        Dim5Info: "",
        Dim6Info: "",
        Dim7Info: "",
        Dim8Info: "",
        Dim9Info: "",
        tglawal: "",
        useAPUnbill: 1,
        kontrakkey: "",
        keterangan: "",
        matauang: "",
        db_kodeacc: "",
        db_namaacc: "",
        kr_kodeacc: "",
        kr_namaacc: "",
        origincost: "",
        totalakan: "",
        Nilaisusut: "",
        kurstrx: 1,
      },
      totalDb: 0,
      totalCr: 0,
      totalRow: 0,
      currency: [],
      uanguser: this.$store.state.user.matauang,
      lblExchRate: "Exchange Rate",
      amortzHist: {
        items: [],
        fields: [
          {
            key: "index",
            label: "No.",
            thStyle: "width:20px",
          },
          {
            key: "tgljadwal",
            label: "Schedule",
          },
          {
            key: "jmlamor",
            label: "Amortized Amount",
            thStyle: "width:100px",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "nomorgl",
            label: "JV Number",
          },
          {
            key: "tgl_gl",
            label: "JV Date",
          },
          {
            key: "akumulasi",
            label: "Accumulation",
            thStyle: "width:100px",
            thClass: "text-right",
            tdClass: "text-right",
          },
        ],
      },
    };
  },
  computed: {
    dimension() {
      return this.$store.state.dimension;
    },
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    matauang() {
      return this.model.matauang;
    },
    kurstrx() {
      return this.model.kurstrx;
    },
    origincost() {
      return this.model.origincost;
    },
  },
  watch: {
    matauang: function (newval) {
      if (newval === this.uanguser) this.model.kurstrx = 1;
    },
    kurstrx: function (newval) {
      this.model.totalakan =
        parseFloat(this.model.origincost) * parseFloat(newval || 1);
    },
    origincost: function (newval) {
      this.model.totalakan =
        parseFloat(this.model.kurstrx || 1) * parseFloat(newval);
    },
  },

  created: async function () {
    const { user } = this.$store.state;
    this.currency = await amortization.currency();
    this.lblExchRate = `Exch. Rate to ${this.uanguser}`;
    if (this.$route.params.juamorttkey) {
      toastr.info("Loading Amortization Detail, please wait");
      try {
        const data = await amortization.detail(this.$route.params);
        const row = data[0][0];
        this.amortzHist.items = data[1];
        // console.log('  this.amortzHist.items = ',this.amortzHist.items)
        for (var key in row) {
          this.model[key] = row[key];
        }
        this.model.tglawal = row.tglawal
          ? moment(row.tglawal).format("YYYY-MM-DD")
          : "";
        this.model.tglAkhirAmor = row.tglAkhirAmor
          ? moment(row.tglAkhirAmor).format("YYYY-MM-DD")
          : "";

        this.model.tglawalB4 = this.model.tglawal;
        this.model.lamathnB4 = this.model.lamathn;
        this.model.lamablnB4 = this.model.lamabln;
        this.model.totalakanB4 = this.model.totalakan;
        console.log("Amortz header: ", this.model);
        this.tanggalBerubah();
        toastr.clear;
        this.$watch("model.db_kodeacc", function (newval) {
          setTimeout(() => {
            if (this.model.db_kodeacc === newval && newval) {
              //   if (newval) {
              const _selected = this.coa.find((p) => p.kodeacc == newval);
              if (_selected) {
                // console.log(' coa diketik : ', _selected);
                this.model.db_kodeacc = _selected.kodeacc;
                this.model.db_namaacc = _selected.namaacc;
                this.$forceUpdate();
                this.dimension.forEach((dim) => {
                  if (_selected[dim.value]) {
                    this.model[dim.value] = _selected[dim.value];
                    this.model[`${dim.value}Txt`] =
                      _selected[`${dim.value}Txt`];
                    // this.model[`${dim.value}Info`] = _selected[`${dim.value}Info`];
                    this.model[`${dim.value}Info`] =
                      _selected[dim.value] +
                      " | " +
                      _selected[`${dim.value}Txt`];
                  }
                });
              } else {
                this.model.db_kodeacc = "";
                this.model.db_namaacc = "";
              }
            }
          }, 1000);
        });

        this.$watch("model.kr_kodeacc", function (newval) {
          setTimeout(() => {
            if (this.model.kr_kodeacc === newval && newval) {
              //   if (newval) {
              const _selected = this.coa.find((p) => p.kodeacc == newval);
              if (_selected) {
                // console.log(' coa diketik : ', _selected);
                this.model.kr_kodeacc = _selected.kodeacc;
                this.model.kr_namaacc = _selected.namaacc;
                this.$forceUpdate();
              } else {
                this.model.kr_kodeacc = "";
                this.model.kr_namaacc = "";
              }
            }
          }, 1000);
        });

        setTimeout(() => {
          this.$forceUpdate();
        }, 300);
      } catch (error) {
        console.log("error : ", error);
        toastr.error(JSON.stringify(error), "ERROR MESSAGE");
      }
    } else {
      this.model.tglawal = moment().format("YYYY-MM-DD");
      this.tahun = this.model.tglawal.substring(0, 4);
      const e = await amortization.getcoa({ tahun: this.tahun });
      this.coa = e;
    }
  },
  methods: {
    refresh(ctx) {
      this.$refs.table.refresh();
    },
    tanggalBerubah: function () {
      const newVal = moment(this.model.tglawal).format("YYYY");
      if (this.tahun != newVal) {
        this.tahun = newVal;
        amortization
          .getcoa({ tahun: this.tahun })
          .then((result) => {
            this.coa = result;
            if (this.coa.length == 0) {
              this.getCoa();
            }
          })
          .catch((err) => {
            console.log("get COA -> ", err);
          });
      } else if (this.coa.length == 0) {
        this.getCoa();
      }
    },
    getCoa: function () {
      this.tahun = (this.$store.state.user.tglaktif || "").substring(0, 4);
      amortization
        .getcoa({ tahun: this.tahun })
        .then((result) => {
          this.coa = result;
        })
        .catch((err) => {
          console.log("get COA -> ", err);
        });
    },
    showLkuCoa(callerObj) {
      this.lkuCoaShow = true;
      this.lkuCoaCaller = callerObj;
    },
    onSelectLkuCoa(_selected) {
      if (this.lkuCoaCaller === "debit") {
        this.model.dbAccount =
          _selected.kodeacc.trim() + " | " + _selected.namaacc.trim();
        this.model.db_kodeacc = _selected.kodeacc;
        this.model.db_namaacc = _selected.namaacc;
      } else {
        this.model.krAccount =
          _selected.kodeacc.trim() + " | " + _selected.namaacc.trim();
        this.model.kr_kodeacc = _selected.kodeacc;
        this.model.kr_namaacc = _selected.namaacc;
      }
      this.lkuCoaShow = false;
    },
    onSelectLkuAp(_selected) {
      this.lkuApShow = false;
      this.model.nomorap = _selected.nomor;
      this.model.apdtlkey = _selected.apdtlkey;
      this.model.keterangan = _selected.uraian_dt;
      this.model.db_uraian = _selected.uraian_dt;
      this.model.kr_uraian = _selected.uraian_dt;
      this.model.kr_kodeacc = (_selected.kodeacc || "").trim();
      this.model.kr_namaacc = _selected.namaacc;
      this.model.matauang = _selected.matauang;
      this.model.origincost = _selected.nilai;
      this.model.kurstrx = _selected.ratekurs;
      this.model.totalakan = _selected.nilai * _selected.ratekurs;
      this.dimension.forEach((dim) => {
        if (_selected[dim.value]) {
          this.model[dim.value] = _selected[dim.value];
          this.model[`${dim.value}Txt`] = _selected[`${dim.value}Txt`];
          // this.model[`${dim.value}Info`] = _selected[`${dim.value}Info`];
          this.model[`${dim.value}Info`] =
            _selected[dim.value] + " | " + _selected[`${dim.value}Txt`];
        }
      });
    },
    // onSelectLkuSka(_selected) {
    //   this.lkuSkaShow=false;
    //   this.model.agreementId= _selected.agreementPriceId;
    //   this.model.agreement_no= _selected.agreement_no;
    //   this.model.agreement_title= _selected.agreement_title;
    // },
    async onSelectLkuApUnbill(_selected) {
      // if (_selected.posting!=1) {
      //     toastr.error('AP CONTRACT/UNBILL belum diposting tidak bisa dipilih, silahkan lakukan posting dulu!');
      //     return;
      // }
      this.lkuApunbillShow = false;
      this.model.nomorap = _selected.nomor;
      this.model.agreementId = _selected.agreementId;
      this.model.kontrakkey = _selected.kontrakKey;
      this.model.vendor = _selected.vendor;
      this.model.vendor_id = _selected.vendor_id;
      this.model.vendorinfo =
        _selected.vendor.trim() + " | " + _selected.vendor_name;
      // this.model.postgroup = (_selected.postgrp || '').trim();
      this.model.matauang = _selected.matauang;
      this.model.origincost = _selected.origincost;
      this.model.kurstrx = _selected.kurstrx || 1;
      this.model.totalakan = _selected.totkontrak;
      if (!this.model.keterangan) {
        this.model.keterangan = _selected.agreement_title;
      }
    },
    save: async function () {
      if (!this.saveEnabled) {
        toastr.warn("View mode cannot be Saved");
        return;
      }
      this.saveEnabled = false;
      if (this.invalidModel) {
        const invalidobj = {};
        for (var key in this.$v.model) {
          if (this.$v.model[key].$anyError) {
            if (this.$v.model[key].$anyError == true)
              invalidobj[key] = this.$v.model[key];
          }
        }
        console.log("validation model: ", this.model);
        console.log("validation field: ", invalidobj);
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
        this.saveEnabled = true;
      } else {
        try {
          let data = {};
          for (var key in this.model) {
            data[key] = this.model[key];
          }
          data.tglawal = moment(this.model.tglawal).format("YYYY-MM-DD");
          data.tglAkhirAmor = moment(this.model.tglAkhirAmor).format(
            "YYYY-MM-DD"
          );

          await amortization.insert(data);
          toastr.success("Complete successfully", "Save Amortization");
          this.close();
        } catch (error) {
          console.log("error : ", error);
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
          this.saveEnabled = true;
        }
      }
    },
    update_uraian: function () {
      this.model.db_uraian = this.model.keterangan
        ? " Amortisasi " + this.model.keterangan
        : "";
      this.model.kr_uraian = this.model.keterangan
        ? " Amortisasi " + this.model.keterangan
        : "";
    },
    update_aspurcpri: function () {
      this.model.totalakan =
        parseFloat(this.model.origincost) * parseFloat(this.model.kurstrx || 1);
      this.$forceUpdate();
    },
    update_monthly_amortisasi: function () {
      this.tanggalBerubah();
      let lamaamortisasi =
        parseFloat(this.model.lamathn || 0) * 12 +
        parseFloat(this.model.lamabln || 0);
      if (lamaamortisasi != 0) {
        this.model.Nilaisusut =
          parseFloat(this.model.totalakan) / lamaamortisasi;
        this.model.tglAkhirAmor = moment(this.model.tglawal, "YYYY-MM-DD")
          .add(lamaamortisasi, "M")
          .format("YYYY-MM-DD");
      }
      this.$forceUpdate();
    },
    close() {
      if (this.$store.state.prevRoute.name) {
        router.push({ name: this.$store.state.prevRoute.name });
      } else {
        router.push({ name: "accounting.amortization" });
      }
    },
  },
};
</script>
